import { combineSlices } from '@reduxjs/toolkit';
import { createAppStore } from '@repo/store';
import { appHooks } from '@repo/store/react';

import { onAuthChange } from '@/utils/api';

import { authSlice, loginUser, logoutUser } from './auth';
import { dashboardSlice } from './dashboard';
import { votePageSync } from './votePageSync';

/** Slices only some routes use, each added beside its own slice with `WithSlice`. */
export interface LazyLoadedSlices {}

export const rootReducer = combineSlices(authSlice, dashboardSlice).withLazyLoadedSlices<LazyLoadedSlices>();

const store = createAppStore({
  reducer: rootReducer,
  middleware: [votePageSync],
  persist: { key: 'iv_dashboard', paths: { auth: ['loggedIn'] } },
});

onAuthChange({
  refreshed: () => store.dispatch(loginUser()),
  expired: () => store.dispatch(logoutUser(false)),
});

export type AppStore = typeof store;
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = AppStore['dispatch'];

export const { useAppDispatch, useAppSelector, useAppStore } = appHooks<AppStore>();

export default store;
